var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-285"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(626 151)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-626 -151)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(626 151)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a-285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.722,260.562S595.577,365,574.262,376.728s126.823,12.789,126.823,12.789-33.038-90.588-18.118-118.3Z",
    transform: "translate(318.813 155.394)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.536,
    cy: 73.536,
    r: 73.536,
    transform: "translate(881.887 324.39)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.257,390.045l-12.32,56.1-26.05,118.69-.78,6.5-8.99,75.25-5.98,49.99-4.01,33.58c-24.38,12.53-42.05,21.18-42.05,21.18s-1.52-7.62-3.97-17.37c-17.11,5.13-48.77,13.64-75.6,15.34,9.77,10.89-141.12-266.12-146.91-303.16-4.66-29.81-8.16-55-8.9-60.36-.1-.7-.15-1.06-.15-1.06l112.43-49.68c7.99,18.53,45.3,24.1,45.3,24.1,30.91-2.13,55.14-18.43,55.14-18.43Z",
    transform: "translate(318.813 155.394)",
    fill: "#131A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.129,154.235l13.749-5.5s-28.749-31.651-68.747-28.9l11.25-12.385s-27.5-11.009-52.5,17.89c-13.141,15.191-28.346,33.048-37.825,53.163H571.33l6.146,13.532-21.509,13.532,22.077-2.431a75.616,75.616,0,0,0-.6,22.445,29.041,29.041,0,0,0,10.634,19h0s17.052-35.3,17.052-40.8v13.761S618.88,205.157,618.88,196.9l7.5,9.633,3.75-15.137,46.248,15.137-7.5-12.385,28.749,4.128-11.25-15.137s32.5,17.89,33.749,33.027,10.762,29.481,10.762,29.481S756.378,174.877,720.129,154.235Z",
    transform: "translate(297.666 174.133)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.187,647.955c-7.49,8.12-26.05,20.35-48.55,33.59-8.37,4.92-17.28,9.99-26.37,15.03-21.69,12.03-44.4,23.95-63.14,33.58-24.38,12.53-42.05,21.18-42.05,21.18s-1.52-7.62-3.97-17.37c-3.28-13.05-8.22-29.92-13.37-37.39-.18-.26-.36-.5-.54-.74-1.5-1.97-3.01-3.12-4.5-3.12l74.42-46.13,32.16-19.94-23.17-55.31-29.06-69.38,17.54-55.81,17.63-56.1h33.04s10.94,23.88,24.93,57.18c2.09,4.98,4.25,10.17,6.45,15.53C869.417,532.755,905.3,630.5,889.187,647.955Z",
    transform: "translate(318.813 155.394)",
    fill: "#131A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.677,695.915a47.792,47.792,0,0,0-8.1.66c-22.99,3.95-29.77,24.76-31.7,38.7a71.847,71.847,0,0,0-.7,12.86l-20.31-15.62-7.4-5.69c-17.81-6.21-33.68-17.24-47.44-30.25a238.478,238.478,0,0,1-31.95-37.89,334.144,334.144,0,0,1-24.72-42.4,31.184,31.184,0,0,1-.43-26.45l25.15-56.05,36.76-81.92q.4-2.925.89-5.72c7.29-41.8,26.82-60.36,26.82-60.36h14.92l9.98,60.36,12.4,74.99-8.69,28.34-20.08,65.45,19.19,20.84Z",
    transform: "translate(318.813 155.394)",
    fill: "#131A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.381,510.145H661.938v-3.431H586.466v3.431H419.337A11.259,11.259,0,0,0,408.079,521.4V749.315a11.259,11.259,0,0,0,11.259,11.259H828.381a11.259,11.259,0,0,0,11.259-11.259V521.4a11.259,11.259,0,0,0-11.259-11.259Z",
    transform: "translate(318.813 119.599)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(921.445 684.314)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8a8f2fec5706ce69f9310747d066bd55.svg";
export { ForwardRef as ReactComponent };